import React from 'react'
import { Helmet } from 'react-helmet'
import './SearchBar.css'

const SearchBar = (props) => {
    return (
        <div className="screen5-container1">
            <div className="screen5-thq-screen5-elm">
                <div className="screen5-thq-depth2-frame0-elm">
                    <div className="screen5-thq-depth3-frame0-elm1">
                        <div className="screen5-thq-depth4-frame0-elm1">
                            <img
                                src="/depth5frame0217-ynws.svg"
                                alt="Depth5Frame0217"
                                className="screen5-thq-depth5-frame0-elm1"
                            />
                        </div>
                        <div className="screen5-thq-depth4-frame1-elm1">
                            <span className="screen5-thq-text-elm1">Skill Swap Platform</span>
                        </div>
                    </div>
                </div>
                <div className="screen5-thq-depth2-frame1-elm">
                    <div className="screen5-thq-depth3-frame0-elm2">
                        <div className="screen5-thq-depth4-frame0-elm2">
                            <div className="screen5-thq-depth5-frame0-elm2">
                                <div className="screen5-thq-depth6-frame0-elm">
                                    <div className="screen5-thq-depth7-frame0-elm">
                                        <img
                                            src="/depth8frame02123-vipa.svg"
                                            alt="Depth8Frame02123"
                                            className="screen5-thq-depth8-frame0-elm"
                                        />
                                    </div>
                                    <div className="screen5-thq-depth7-frame1-elm">
                                        <span className="screen5-thq-text-elm2">
                                            Search by name or skill
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="screen5-thq-depth4-frame1-elm2"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SearchBar
